import { orgIDMap } from "./orgIdMap";

export const getOrgConfig = (orgId: string) => {
  const finalId = orgIDMap[orgId];
  console.log({ finalId });
  const userPoolIdKey = `REACT_APP_${finalId}_USER_POOL_ID`;
  const clientIdKey = `REACT_APP_${finalId}_CLIENT_ID`;

  return {
    userPoolId: process.env[userPoolIdKey] || "",
    clientId: process.env[clientIdKey] || "",
  };
};
